<template>
  <div class="user-center">
    <div class="user-content">
      <WalletCard
        :balance="balance"
        :user-info="userInfo"
        :show-apply-broker="showApplyBroker"
        @click="onJump('/my/myBalance')"
        @points-click="onJump('/pc/my/myBalance?tab=points')"
        @apply-broker="onJump('/applybroker')"
      />

      <QuickEntrySection
        :entries="quickEntries"
        @click="handleQuickEntryClick"
      />

      <div class="service-container">
        <!-- 精选交易 -->
        <ServiceSection
          v-if="detail.businessType != 0"
          :title="$t('account.featuredTrade')"
          :services="tradeServices"
          @click="handleServiceClick"
        />

        <!-- <ServiceSection
          v-if="hasYanHuo || hasFollowOrder"
          title="我的服务"
          :services="myServices"
          @click="handleServiceClick"
        /> -->
      </div>
    </div>
  </div>
</template>

<script>
import { getUserInfoDetail, getUserBalance } from "@/api/user.js";
import { getKbPointsBalance } from "@/api/xunzhiKb";
import { Toast } from "vant";
import WalletCard from "@/components/pc/user/WalletCard.vue";
import QuickEntrySection from "@/components/pc/user/QuickEntrySection.vue";
import ServiceSection from "@/components/pc/user/ServiceSection.vue";

export default {
  name: "UserPage",
  components: {
    WalletCard,
    QuickEntrySection,
    ServiceSection,
  },
  data() {
    return {
      avatarImg: require("@/assets/default-avatar.png"),
      detail: {},
      balance: {
        totalBalance: 0,
        frozenBalance: 0,
        withdrawableBalance: 0,
        jf: 0,
        jb: 0,
      },
    };
  },
  created() {
    if (this.isLogin) {
      this.getUserInfoDetail();
    }
  },
  computed: {
    isLogin() {
      return this.$store.getters.token;
    },
    showApplyBroker() {
      return this.detail.businessType == 0 && this.detail.shopStatus == null;
    },
    userTypeIcon() {
      const typeMap = {
        0: "user",
        10: "user-solid",
        20: "s-custom",
      };
      return typeMap[this.detail.businessType] || "user";
    },
    userInfo() {
      return {
        avatar: this.detail.avatar,
        authnName: this.detail.authnName,
        nick_name: this.detail.nick_name,
        mobile: this.detail.mobile,
        userType: this.detail.userType,
        userTypeIcon: this.userTypeIcon,
        businessType: this.detail.businessType,
        goodlevel: this.detail.goodlevel,
      };
    },
    hasFollowOrder() {
      if (!this.detail) return false;
      return this.detail.businessType == 10 || this.detail.businessType == 20;
    },
    hasYanHuo() {
      if (!this.detail) return false;
      return this.detail.businessType == 40;
    },
    // 商品库、供应商管理仅对指定（privateRole-4/5）内部角色开放，和左侧菜单权限保持一致。
    hasGoodsLibraryPermission() {
      return [4, 5].includes(this.detail.privateRole);
    },
    quickEntries() {
      return [
        {
          // 交易订单
          label: this.$t("account.tradeOrders"),
          icon: "document",
          path: "/myxg/myTransactionOrder",
        },
        {
          // 商品中心
          label: this.$t("account.goodsCenter"),
          icon: "goods",
          path: "/myxg/myGoods",
        },
        {
          // 消息管理
          label: this.$t("account.messages"),
          icon: "message",
          path: "/myxg/messageCenter",
        },
      ];
    },
    tradeServices() {
      const services = [
        {
          // 交易订单
          label: this.$t("account.tradeOrders"),
          icon: "document",
          path: "/myxg/myTransactionOrder",
          disabled: false,
        },
        {
          // 商品中心
          label: this.$t("account.goodsCenter"),
          icon: "goods",
          path: "/myxg/myGoods",
          disabled: false,
        },
        {
          // 消息管理
          label: this.$t("account.messages"),
          icon: "message",
          path: "/myxg/messageCenter",
          disabled: false,
        },
      ];

      if (this.hasGoodsLibraryPermission) {
        services.splice(
          2,
          0,
          {
            // 商品库
            label: this.$t("account.goodsLibrary"),
            icon: "box",
            path: "/myxg/goodsLibrary",
            disabled: false,
          },
          {
            // 供应商管理
            label: this.$t("account.suppliers"),
            icon: "set-up",
            path: "/myxg/supplierList",
            disabled: false,
          }
        );
      }

      return services;
    },
    myServices() {
      const services = [];
      if (this.hasYanHuo) {
        services.push({
          label: "我的验货",
          icon: "document",
          path: "/myxg/myYanHuo",
          disabled: false,
        });
      }
      if (this.hasFollowOrder) {
        services.push({
          label: "我的评价",
          icon: "star",
          path: "/myxg/myFollowOrderList",
          disabled: false,
        });
      }
      return services;
    },
  },
  methods: {
    async getUserInfoDetail() {
      const [userInfoResult, balanceResult, pointsResult] =
        await Promise.allSettled([
          getUserInfoDetail(),
          getUserBalance(),
          getKbPointsBalance(),
        ]);

      if (
        userInfoResult.status === "fulfilled" &&
        userInfoResult.value.code === 200
      ) {
        this.detail = userInfoResult.value.data.userInfo;
      }
      if (
        balanceResult.status === "fulfilled" &&
        balanceResult.value.code === 200
      ) {
        // 当前“积分”优先展示百科本地积分，避免继续显示商城接口中
        // 尚未接入中央账本的 jf 字段。
        this.balance = { ...balanceResult.value.data, jf: 0 };
      }
      if (pointsResult.status === "fulfilled") {
        const encyclopediaPoints = Number(pointsResult.value?.data?.balance);
        this.balance = {
          ...this.balance,
          jf: Number.isFinite(encyclopediaPoints) ? encyclopediaPoints : 0,
        };
      } else {
        // 百科服务暂不可用时，资产页仍可显示商城余额；积分明确显示为 0，
        // 不回退到商城的旧 jf 字段以免造成数据来源混淆。
        console.warn("获取百科积分余额失败", pointsResult.reason);
      }
    },
    onJump(url) {
      if (!this.isLogin) {
        // 请先登录
        Toast.fail(this.$t("personalMenu.loginFirst"));
        return;
      }
      this.$router.push(url);
    },
    handleQuickEntryClick(item) {
      this.onJump(item.path);
    },
    handleServiceClick(item) {
      this.onJump(item.path);
    },
  },
};
</script>

<style lang="less" scoped>
.user-center {
  .user-content {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }
}

.service-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
</style>
